const { default: Profile } = require('../components/svgs/sider/Profile')
const { default: ProfileA } = require('../components/svgs/sider/ProfileA')
const { default: Services } = require('../components/svgs/sider/Services')
const { default: ServicesA } = require('../components/svgs/sider/ServicesA')
const { default: Requests } = require('../components/svgs/sider/Requests')
const { default: RequestsA } = require('../components/svgs/sider/RequestsA')
const { default: Payments } = require('../components/svgs/sider/Payments')
const { default: PaymentsA } = require('../components/svgs/sider/PaymentsA')
const { default: FollowUp } = require('../components/svgs/sider/FollowUp')
const { default: FollowUpA } = require('../components/svgs/sider/FollowUpA')
const { default: Subscriptions } = require('../components/svgs/sider/Subscriptions')

const subscriptionsSubmenu = [
  {
    key: 'subscription-annuale',
    path: 'my-subscriptions',
    title: 'CAF e Patronato',
  },
  {
    key: 'subscription-colf-badanti',
    path: 'abbonamenti/colf-e-badanti',
    title: 'Colf e Badanti',
  },
  {
    key: 'subscription-smart-forfettario',
    path: 'abbonamenti/smart-forfettario',
    title: 'Smart Forfettario',
  },
]

let navTree

if (process.env.NEXT_PUBLIC_ENVIRONMET === 'development') {
  navTree = [
    {
      key: 'profile',
      path: 'profile',
      title: 'profile.title',
      icon: <Profile />,
      iconActive: <ProfileA />,
    },
    {
      key: 'services',
      path: 'servizi',
      title: 'sidenav.Services',
      icon: <Services />,
      iconActive: <ServicesA />,
    },
    {
      key: 'requests',
      path: 'requests',
      title: 'sidenav.Requests',
      icon: <Requests />,
      iconActive: <RequestsA />,
    },
    {
      key: 'my-subscriptions',
      path: 'my-subscriptions',
      title: 'sidenav.Subscriptions',
      icon: <Subscriptions />,
      iconActive: <Subscriptions isActive={true} />,
      submenu: subscriptionsSubmenu,
    },
    {
      key: 'Payments',
      path: 'payments',
      title: 'sidenav.Payments',
      icon: <Payments />,
      iconActive: <PaymentsA />,
    },
    {
      key: 'followUp',
      path: 'tickets',
      title: 'Follow up Inquiries',
      icon: <FollowUp />,
      iconActive: <FollowUpA />,
    },
  ]
} else {
  navTree = [
    {
      key: 'profile',
      path: 'profile',
      title: 'profile.title',
      icon: <Profile />,
      iconActive: <ProfileA />,
    },
    {
      key: 'services',
      path: 'servizi',
      title: 'sidenav.Services',
      icon: <Services />,
      iconActive: <ServicesA />,
    },
    {
      key: 'requests',
      path: 'requests',
      title: 'sidenav.Requests',
      icon: <Requests />,
      iconActive: <RequestsA />,
    },
     {
      key: 'my-subscriptions',
      path: 'my-subscriptions',
      title: 'sidenav.Subscriptions',
      icon: <Subscriptions />,
      iconActive: <Subscriptions isActive={true} />,
      submenu: subscriptionsSubmenu,
    },
    {
      key: 'Payments',
      path: 'payments',
      title: 'sidenav.Payments',
      icon: <Payments />,
      iconActive: <PaymentsA />,
    },
    {
      key: 'followUp',
      path: 'tickets',
      title: 'Follow up Inquiries',
      icon: <FollowUp />,
      iconActive: <FollowUpA />,
    },
  ]
}

export default navTree
